import React from "react";
import IOrder from "../../../models/IOrder";

type Props = {
    order: IOrder;
};

export const StripePaymentCapture = (props: Props) => {
    return (
        <div className={"StripePaymentCapture"}>
            <div className={"mb-3 d-flex align-items-center justify-content-end"}></div>
        </div>
    );
};
